import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import PersonService from "../../../Services/Person.service";
const displayPersonTypes = (person) => {
    if (person.personTypes) {
        return person.personTypes.map((type) => type.name).join(", ");
    }
    return "None";
};
const makeSearchArgs = {
    loadOptions: (search, options) => {
        if (options.forceEmptyReturn) {
            return new Promise((resolve) => {
                resolve([]);
            });
        }
        return PersonService.searchPeople({
            personTypeInternalNames: options.personTypeInternalNames,
            ids: options.ids,
            excludePersonIds: options.excludePersonIds,
            query: search,
        });
    },
    label: (person) => {
        if (!person.personTypes || person.personTypes.length === 0) {
            return `${person.fullName} (${person.studentId})`;
        }
        return `${person.fullName} (${displayPersonTypes(person)}) (${person.studentId})`;
    },
    value: "studentId",
};
export const PersonSearch = makeSearch(makeSearchArgs);
export const PersonMultiSearch = makeMultiSearch(makeSearchArgs);
